module.exports = __webpack_public_path__ + "static/media/food-bg.cc57d99a.png";